module.exports = __webpack_public_path__ + "img/chat-icon.82bfc95f.svg";